import React from 'react'
import {Button, ButtonGroup, CircularProgress} from '@mui/material'
import Grid from "@mui/material/Grid2"
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {planApiActions, authenticationActions, armouringDocumentsActions} from '../../actions'
import {apiUrls} from '../../constants'
import {RootState} from '../../reducers'

type PlanSummary = {
    id: number | string
    linkId: string
    hasLid: boolean
    lidIsStandard: boolean
    lidType: string
    lidCollar: string
    hasIntermediateCeiling: boolean
}

type ProjectSummary = { id: number | string }

type Props = {
    plan: PlanSummary
    project?: ProjectSummary
}

export const ActionButtons: React.FC<Props> = ({plan, project}) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const apiRequestState = useSelector((state: RootState) => state.apiRequestState as any)
    const isAdmin = useSelector((state: RootState) => (state as any).user?.isAdmin) as boolean | undefined

    const isCreateArmouringDocsEnabled = () => {
        if (!isAdmin) return false
        if (plan.hasIntermediateCeiling) return true
        if (!plan.hasLid) return false
        if (plan.lidIsStandard) return false
        if (!['a15', 'b125', 'd400', 'e600'].includes(plan.lidType.toLowerCase())) return false
        if (!['beveled', 'lifted', 'pavingready'].includes(plan.lidCollar.toLowerCase())) return false
        return true
    }

    const isCreatingArmouringDocsForThis = () =>
        !!apiRequestState &&
        apiRequestState.request === 'create_armouring_documents' &&
        apiRequestState.planId === plan.id &&
        apiRequestState.state === 'pending'

    const isCreatingArmouringDocsForOther = () =>
        !!apiRequestState &&
        apiRequestState.request === 'create_armouring_documents' &&
        apiRequestState.planId !== plan.id &&
        apiRequestState.state === 'pending'

    return (
        <ButtonGroup variant="text" aria-label="text button group">
            <Button
                onClick={() => {
                    dispatch(authenticationActions.extendLoginIfRequired() as any)
                    dispatch(planApiActions.readPlan(plan.id, history) as any)
                }}
            >
                Als Vorlage öffnen
            </Button>

            <Button
                onClick={() => {
                    window.open(
                        apiUrls.planPdfDownload +
                        '?linkId=' +
                        plan.linkId +
                        '&XDEBUG_SESSION_START=PHPSTORM'
                    )
                }}
            >
                PDF anzeigen
            </Button>

            {isCreateArmouringDocsEnabled() && (
                <React.Fragment>
                    {isCreatingArmouringDocsForThis() ? (
                        <Grid>
                            <CircularProgress style={{marginTop: '4px', marginLeft: '2em'}}/>
                        </Grid>
                    ) : isCreatingArmouringDocsForOther() ? (
                        <Button disabled={true}>Armierung generieren</Button>
                    ) : (
                        <Button
                            onClick={() => {
                                dispatch(authenticationActions.extendLoginIfRequired() as any)
                                dispatch(
                                    armouringDocumentsActions.createArmouringDocuments(
                                        plan.id,
                                        !!project && project.id
                                    ) as any
                                )
                            }}
                        >
                            Armierung generieren
                        </Button>
                    )}
                </React.Fragment>
            )}
        </ButtonGroup>
    )
}

